import React from "react"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"

export default function AccountInfo({ headingAccountInformation, labelMembershipNumber, labelPassword, editPasswordLinkLabel }) {
  const { membershipNumber, setIsPasswordModalOpen } = useProfileStore()

  return (
    <div className="form--profile__account-info">
      <div className="form__section form__section--no-border clearfix">
        <h4>{headingAccountInformation}</h4>
        <div className="form__section__inner">
          <div className="grid">
            <div className="grid-item col--12 col-sm--6">
              <h5>{labelMembershipNumber}</h5>
              <p>{membershipNumber}</p>
            </div>
            <div className="grid-item col--12 col-sm--3">
              <h5>{labelPassword}</h5>
              <p>********</p>
            </div>
            <div className="grid-item col--12 col-sm--3">
              <button className="button--link link" onClick={(e) => setIsPasswordModalOpen(e)}>
                <span className="link">{editPasswordLinkLabel}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AccountInfo.propTypes = {
  headingAccountInformation: PropTypes.string.isRequired,
  labelMembershipNumber: PropTypes.string.isRequired,

  labelPassword: PropTypes.string.isRequired,
  editPasswordLinkLabel: PropTypes.string.isRequired,
}
